import { useEffect, useState, useContext, useMemo, useRef } from "react";
import 'react-quill/dist/quill.snow.css';
import './Chat.css';
import moment from "moment";
import Linkify from 'react-linkify';
import { db, storage, } from "../../utils/firebase";
import { ChatRefContext } from "../../context/chatRef.context";
import { getSignedUrlForFile } from "../../utils/actions/userActions";
import { useInstance } from "../../context/instance.context";
import jwt_decode from "jwt-decode";
import ReactQuill from "react-quill";
import { DeleteIcon, LucidLoader } from "../../component/icons";
import PDFModalViewer from "../PDFViewerModal/PDFModalViewer";
import ImageModalViewer from "../ImageViewerModal/ImageModalViewer";
import { toast } from "react-toastify";




function isEditorContentEmpty(html) {
    const cleaned = html
        .replace(/<p><br><\/p>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, '')
        .trim();

    return cleaned.length === 0;
}


function Chat({ onDrawerClose }) {
    let { selectedChatRefId, setSelectedChatRefId, chatType } = useContext(ChatRefContext);
    let localSelectedChatRefId = selectedChatRefId;
    const [isClosedChat, setIsClosedChat] = useState(false);
    const oldRefId = selectedChatRefId;
    if (localSelectedChatRefId && typeof localSelectedChatRefId === 'string') {
        localSelectedChatRefId = localSelectedChatRefId.split(' ')[0];
        if (localSelectedChatRefId.startsWith('S')) {
            localSelectedChatRefId = localSelectedChatRefId.slice(1)
        }
    }
    const { organizationName } = useInstance();


    // console.log("selectedahcat ref",selectedChatRefId)
    if (selectedChatRefId && typeof selectedChatRefId === 'string') {
        let newSelectedChatRefId = selectedChatRefId.split(' ')[0];
        if (selectedChatRefId.startsWith('S')) {
            newSelectedChatRefId = newSelectedChatRefId.slice(1)
            setSelectedChatRefId(newSelectedChatRefId)
        }
    }
    console.log("Selected Cat Ref Id :", selectedChatRefId);
    let loggedInUserFirstName = localStorage.getItem('firstName');
    let loggedInUserLastName = localStorage.getItem('lastName');
    const [downloadAttachmentIndex, setDownloadAttachmentIndex] = useState(null);
    const [downloadAttachmentIndexAttachmentSection, setDownloadAttachmentIndexAttachmentSection] = useState(null);

    const [addingAttachment, setAddAttachment,] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const fileInputRef = useRef(null);
    const messagesEndRef = useRef(null);
    let token = localStorage.getItem("Token");
    let decodedJwt = {};
    if (token) {
        decodedJwt = jwt_decode(token)
    }
    console.log("JWT Data :", decodedJwt);

    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [keys, setKeys] = useState([]);
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [pdfModalInfo, setPdfModalInfo] = useState({
        show: false,
        fileName: '',
        pdfUrl: ''
    });
    const [imageModalInfo, setImageModalInfo] = useState({
        show: false,
        fileName: '',
        imageUrl: ''
    });
    const [activeTab, setActiveTab] = useState('chat');
    const totalMessageCount = useMemo(() => {
        return keys.reduce((count, key) => count + (messages[key]?.length || 0), 0);
    }, [keys, messages]);
    const attachmentCount = attachments.length;
    const normalizedRefLabel = oldRefId || localSelectedChatRefId || "Thread";
    const isSupplierThread = chatType === 'supplier';
    const threadLabel = isSupplierThread ? 'Supplier thread' : 'Customer thread';
    const isChatOpen = !isClosedChat && typeof selectedChatRefId === 'string' && selectedChatRefId.length > 0;
    const quillModules = useMemo(() => ({
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'clean']
        ]
    }), []);
    const quillFormats = useMemo(() => [
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'bullet',
        'link'
    ], []);

    const [imageCache, setImageCache] = useState({});

    const getSignedUrlForImage = async (fileName) => {
        try {
            const response = await getSignedUrlForFile(encodeURIComponent(fileName), 'json');
            return response.data.signedUrl;
        } catch (error) {
            console.error('Error fetching signed URL:', error);
            return null;
        }
    };

    const loadImagePreview = async (fileName) => {
        if (imageCache[fileName]) {
            return imageCache[fileName];
        }
        const signedUrl = await getSignedUrlForImage(fileName);
        if (signedUrl) {
            setImageCache(prev => ({ ...prev, [fileName]: signedUrl }));
            return signedUrl;
        }
        return null;
    };

    const onClose = () => {
        // setOpen(false);
        if (selectedChatRefId && typeof selectedChatRefId === 'string')
            db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).update({
                isOnline: false,
                RefId: selectedChatRefId,
                email: decodedJwt.email,
                firstName: loggedInUserFirstName || decodedJwt?.firstName,
                lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                lastOnline: new Date().toString()
            });
        setIsClosedChat(true);
        if (typeof onDrawerClose === 'function') {
            onDrawerClose();
        }
    };

    const scrollToBottom = () => {
        if (activeTab === 'chat' && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    console.log('RefId in chat component:', selectedChatRefId);

    const onSend = async (attachmentUrl = null, attachmentName = null) => {
        try {
            console.log('On send click message', selectedChatRefId, "   fsafsa");
            console.log('message', message);
            console.log('AttachmentUrl', attachmentUrl);
            if ((isEditorContentEmpty(message) || !message) && !attachmentUrl) {
                console.warn("Cannot send an empty message.");
                return;
            }

            if (selectedChatRefId && typeof selectedChatRefId === 'string') {
                const snapshot = await db.ref('/count/' + selectedChatRefId).get();
                let count = 0;
                if (snapshot.exists()) {
                    count = snapshot.val();
                } else {
                    count = 0;
                }
                const msgId = new Date().getTime()
                const messageObj = {
                    text: !attachmentUrl ? message : null,
                    type: attachmentUrl ? "attachment" : "text",
                    attachmentName: attachmentName,
                    createdon: new Date().toString(),
                    userid: decodedJwt._id,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    url: attachmentUrl
                }

                console.log("Message Object :", messageObj);
                if (messageObj.text === '') return;
                db.ref('/messages/' + selectedChatRefId + '/' + msgId).set(messageObj)
                    .then((something) => console.log('Message sent successfully:', something))
                    .catch(err => console.log("Error in mesafe send", err));
                db.ref('/count/' + selectedChatRefId).set(count + 1);

                // console.log('----------3---------')
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                    msgId: msgId,
                    count: count + 1,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                });
                db.ref("/timings/" + selectedChatRefId).update({
                    lastOnline: new Date().toString(),
                    isEveryoneOffline: false,
                });
                if (!attachmentUrl) {
                    setMessage("")
                }

                console.log("Cam here after sending message");
            }
        }
        catch (err) {
            console.log("err", err)
        }

    }

    const _onChange = (value) => {
        setMessage(value)
    }

    const handleKeySort = (arrayToSort,) => {
        let data = [...arrayToSort].sort((a, b) => {
            return moment(a).isAfter(b) ? 1 : -1
        });
        return data;
    }

    useEffect(() => {
        if (selectedChatRefId && typeof selectedChatRefId === 'string') {
            setIsClosedChat(false);
            // console.log('--------c---------',RefId)
            // console.log('----------1---------')
            db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).get().then(async snapshot => {
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).onDisconnect().update({
                    isOnline: false,
                    RefId: selectedChatRefId,
                    lastOnline: new Date().toString()
                });

                let value = {
                    count: 0,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                };

                if (snapshot.exists()) {
                    value = snapshot.val();
                }

                const snapshotVal = await db.ref('/count/' + selectedChatRefId).get();

                if (snapshotVal.exists()) {
                    const count = snapshotVal.val();
                    value.count = count;
                }

                // console.log('----------2---------')
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                    ...value,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                })
                db.ref("/timings/" + selectedChatRefId).update({
                    lastOnline: new Date().toString(),
                    isEveryoneOffline: false,
                });
            });

        }
    }, [selectedChatRefId])

    useEffect(() => {
        console.log('Use effect with dependency called', selectedChatRefId);
        if (selectedChatRefId && typeof selectedChatRefId === 'string') {
            setIsChatLoading(true);
            const ref = db.ref('/messages/' + selectedChatRefId);
            const onValueChange = (snapshot) => {
                const data = snapshot.val();
                let messagesArr = [];
                if (data) {
                    const updatedData = {};
                    Object.keys(data).forEach((key) => {
                        const innerObj = data[key];
                        innerObj.key = key;
                        updatedData[key] = innerObj;
                    });
                    messagesArr = Object?.values(updatedData);
                }

                console.log('messages fetched:', messagesArr);


                // Use a single, consistent date format for grouping
                const property = 'createdon';
                const array = messagesArr.map(mess => {
                    const date = new Date(mess.createdon);
                    return {
                        ...mess,
                        'createdon': moment(mess.createdon).format('MMM DD, YYYY'),
                        'time': date.getHours() + ':' + (date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes())
                    }
                });
                const arr = array.reduce(function (groups, item) {
                    var name = item[property]
                    var group = groups[name] || (groups[name] = []);
                    group.push(item);
                    return groups;
                }, {});

                const keysArr = Object.keys(arr);
                const sortedKey = handleKeySort(keysArr);
                console.log("Sorted Keys :", sortedKey);
                console.log("Arr :", arr);
                setKeys(sortedKey);
                setMessages(arr);
                setIsChatLoading(false);
            };

            ref.on('value', onValueChange);

            // Cleanup: remove listener on unmount or when selectedChatRefId changes
            return () => {
                ref.off('value', onValueChange);
            };
        }
    }, [selectedChatRefId])

    // Helper to extract attachments from messages
    const extractAttachments = (messagesObj, keysArr) => {
        let arr = [];
        keysArr.forEach(key => {
            if (messagesObj[key]) {
                messagesObj[key].forEach(message => {
                    if (message.type === "attachment") {
                        arr.push(message);
                    }
                });
            }
        });
        return arr;
    };

    // Update attachments whenever messages or keys change
    useEffect(() => {
        setAttachments(extractAttachments(messages, keys));
        // Auto-scroll when messages update
        scrollToBottom();
    }, [messages, keys, activeTab]);

    const uploadFiles = (file) => {
        if (!file) return;
        try {
            setAddAttachment(true);
            let fileNameForDownload = `${Date.now()}_${file.name}`;
            const uploadTask = storage.ref(`/files/${fileNameForDownload}`).put(file);

            uploadTask.on("state_changed", () => {
            },
                (err) => {
                    console.error("Upload error:", err);
                    toast.error(`Failed to upload file: ${file.name}`);
                    setAddAttachment(false);
                },
                async () => {
                    try {
                        await onSend(fileNameForDownload, file.name);
                        // After upload, refresh attachments
                        setAttachments(extractAttachments(messages, keys));
                    } catch (err) {
                        console.error("Error after upload:", err);
                        toast.error("File uploaded but failed to send message update.");
                    } finally {
                        setAddAttachment(false);
                    }
                }
            )
        } catch (err) {
            console.error('Something went wrong during upload init:', err);
            toast.error("Something went wrong. Please try again.");
            setAddAttachment(false);
        }
    }

    const handleFileDownload = async (fileNameForDownload, fileName, j, type) => {
        if (type == 'chat') {
            setDownloadAttachmentIndex(j);
        }
        else {
            setDownloadAttachmentIndexAttachmentSection(j);
        }
        try {
            const responseType = fileName.endsWith('.pdf') ? 'json' : 'blob';
            console.log('Response type ::', responseType);

            const encodedURL = encodeURIComponent(fileNameForDownload);
            const response = await getSignedUrlForFile(encodedURL, responseType);
            if (responseType === 'json') {
                const { signedUrl } = response.data;
                setPdfModalInfo({
                    show: true,
                    fileName: fileName,
                    pdfUrl: `${process.env.REACT_APP_API_ENDPOINT}/common/view-file?url=${encodeURIComponent(signedUrl)}`
                });
                if (typeof onDrawerClose == 'function') {
                    onDrawerClose();
                }
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the desired file name
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.log('err', err)
        } finally {
            if (type == 'chat') {
                setDownloadAttachmentIndex(null);
            }
            else {
                setDownloadAttachmentIndexAttachmentSection(null);
            }
        }
    }


    const name = (message) => {
        console.log('message.email', message?.email, message)
        if (message?.firstName && message?.lastName && message?.lastName != 'undefined' && message?.email.includes(`${organizationName?.split(" ")?.pop()?.toLowerCase()}`)) {
            return message.firstName + ' ' + (message?.lastName || "") + ` (${organizationName?.split(" ")?.pop()?.toLowerCase() || ""})`;
        } else if (message?.firstName && (message?.lastName || "") && message?.lastName != 'undefined') {
            return message.firstName + ' ' + (message.lastName || "");
        } else {
            return message.firstName;
        }
    };

    const handleMessageDelete = async (message) => {
        try {
            const confirmed = window.confirm('Are you sure you want to delete the message?');
            if (!confirmed) {
                return;
            }

            await db.ref('/messages/' + selectedChatRefId + '/' + message.key).remove();

            const countSnapshot = await db.ref("/count/" + selectedChatRefId).once("value");
            const count = countSnapshot.val() || 0;
            await db.ref('/count/' + selectedChatRefId).set(count - 1);

            const userSnapShot = await db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).get();
            const userData = userSnapShot.val();

            await db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                ...userData,
                count: count - 1,
            });

            toast.success('Message deleted successfully');
        } catch (err) {
            console.log("Error", err);
            toast.error('Failed to delete message');
        }
    }

    const isLink = (text) => {
        if (typeof text !== 'string') return false;
        const plainText = text.replace(/<[^>]+>/g, '').trim();
        return /^https?:\/\/[^\s]+$/i.test(plainText);
    };

    const getLinkText = (text) => {
        if (typeof text !== 'string') return '';
        return text.replace(/<[^>]+>/g, '').trim();
    };

    const isImageAttachment = (fileName = '') => {
        return /(png|jpg|jpeg|webp)$/i.test(fileName || '');
    };

    const getMessageHtml = (text) => {
        if (typeof text !== 'string') return '';
        return text.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
    };

    const renderMessageText = (text, isOwnMessage) => {
        if (!text) return null;
        if (isLink(text)) {
            return (
                <a
                    href={getLinkText(text)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`break-all text-[13px] font-medium underline ${isOwnMessage ? 'text-white' : 'text-sky-700'}`}
                >
                    {getLinkText(text)}
                </a>
            );
        }

        return (
            <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="_blank" rel="noopener" href={decoratedHref} key={key}>
                        {decoratedText}
                    </a>
                )}
            >
                <div
                    className={`break-words text-[13px] leading-6 ${isOwnMessage ? 'text-white' : 'text-slate-700'}`}
                    dangerouslySetInnerHTML={{
                        __html: getMessageHtml(text)
                    }}
                />
            </Linkify>
        );
    };

    const renderAttachmentCard = (item, index, type) => {
        const isDownloading = type === 'chat'
            ? downloadAttachmentIndex === index
            : downloadAttachmentIndexAttachmentSection === index;

        const handleImageClick = async () => {
            try {
                let signedUrl = imageCache[item.url];
                if (!signedUrl) {
                    signedUrl = await getSignedUrlForImage(item.url);
                    if (signedUrl) {
                        setImageCache(prev => ({ ...prev, [item.url]: signedUrl }));
                    }
                }
                if (signedUrl) {
                    setImageModalInfo({
                        show: true,
                        fileName: item.attachmentName,
                        imageUrl: `${process.env.REACT_APP_API_ENDPOINT}/common/view-file?url=${encodeURIComponent(signedUrl)}`
                    });
                } else {
                    toast.error('Failed to load image');
                }
            } catch (error) {
                console.error('Error loading image:', error);
                toast.error('Failed to load image');
            }
        };

        const ImagePreview = () => {
            const [previewUrl, setPreviewUrl] = useState(imageCache[item.url] || null);

            useEffect(() => {
                if (!previewUrl && isImageAttachment(item?.url)) {
                    loadImagePreview(item.url).then(url => {
                        if (url) setPreviewUrl(url);
                    });
                }
            }, []);

            if (previewUrl) {
                return (
                    <img
                        src={previewUrl}
                        alt={item.attachmentName}
                        className="w-full h-auto"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                );
            }
            return (
                <div className="w-full h-40 flex items-center justify-center bg-slate-100">
                    <svg className="w-12 h-12 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
            );
        };

        return (
            <div className="mt-2 rounded-xl border border-slate-200 bg-white p-2.5 shadow-sm">
                {isImageAttachment(item?.url) ? (
                    <button
                        onClick={handleImageClick}
                        className="w-full overflow-hidden rounded-xl border border-slate-200 bg-slate-50 hover:opacity-80 transition-opacity"
                    >
                        <ImagePreview />
                    </button>
                ) : (
                    <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-3">
                        <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
                            Attachment
                        </p>
                        <p className="mb-0 break-all text-[13px] font-semibold text-slate-700">
                            {item.attachmentName}
                        </p>
                    </div>
                )}
                <div className="mt-2 flex items-center justify-between gap-3">
                    <span className="truncate text-[11px] text-slate-500">
                        {item.attachmentName}
                    </span>
                    {isDownloading ? (
                        <div className="flex items-center justify-center">
                            <LucidLoader />
                        </div>
                    ) : (
                        <button
                            className="rounded-full border border-slate-300 bg-slate-50 px-3 py-1 text-[12px] font-semibold text-slate-700 transition hover:bg-slate-100"
                            onClick={() => handleFileDownload(item.url, item.attachmentName, index, type === 'chat' ? 'chat' : 'att')}
                        >
                            Download
                        </button>
                    )}
                </div>
            </div>
        );
    };

    const renderEmptyState = (title, subtitle) => (
        <div className="mx-auto mt-6 flex max-w-[320px] flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-5 py-7 text-center shadow-sm">
            <div className="mb-4 rounded-full border border-slate-200 bg-white px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500 shadow-sm">
                {threadLabel}
            </div>
            <h3 className="mb-2 text-[18px] font-semibold text-slate-800">{title}</h3>
            <p className="mb-0 text-[13px] leading-6 text-slate-500">{subtitle}</p>
        </div>
    );

    console.log("messages ::", messages);



    return (
        <>
            <div>
                {isChatOpen ? (
                    <div className="sync-chat-overlay" onClick={onClose}>
                        <div
                            className="sync-chat-drawer"
                            onClick={(event) => event.stopPropagation()}
                        >
                            <div className="sync-chat-header">
                                <div className="flex items-start justify-between gap-3">
                                    <div className="min-w-0">
                                        <div className="mb-1.5 flex flex-wrap items-center gap-2">
                                            <span className={`sync-chat-badge ${isSupplierThread ? 'sync-chat-badge-supplier' : 'sync-chat-badge-customer'}`}>
                                                {threadLabel}
                                            </span>
                                            <span className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-medium text-slate-600">
                                                {totalMessageCount} messages
                                            </span>
                                            <span className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-medium text-slate-600">
                                                {attachmentCount} attachments
                                            </span>
                                        </div>
                                        <h2 className="sync-chat-title truncate">
                                            {normalizedRefLabel}
                                        </h2>
                                        <p className="sync-chat-subtitle">
                                            Share updates, approvals, screenshots, and files in one clean thread.
                                        </p>
                                    </div>
                                    <button
                                        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
                                        onClick={onClose}
                                        aria-label="Close chat"
                                    >
                                        <span className="text-xl leading-none">×</span>
                                    </button>
                                </div>
                            </div>

                            <div className="border-b border-slate-200 bg-white px-4 py-2.5 sm:px-5">
                                <div className="flex max-w-[260px] gap-1.5 rounded-full bg-slate-100 p-1">
                                    <button
                                        className={`flex-1 rounded-full px-3 py-1.5 text-sm font-semibold transition ${activeTab === 'chat' ? 'bg-slate-900 text-white shadow-sm' : 'text-slate-600 hover:bg-white'}`}
                                        onClick={() => setActiveTab('chat')}
                                    >
                                        Chat
                                    </button>
                                    <button
                                        className={`flex-1 rounded-full px-3 py-1.5 text-sm font-semibold transition ${activeTab === 'attachments' ? 'bg-slate-900 text-white shadow-sm' : 'text-slate-600 hover:bg-white'}`}
                                        onClick={() => setActiveTab('attachments')}
                                    >
                                        Attachments
                                    </button>
                                </div>
                            </div>

                            <div className="relative min-h-0 flex-1 flex flex-col">
                                {addingAttachment && (
                                    <div className="absolute inset-0 z-[20] flex animate-in fade-in duration-300 items-center justify-center bg-white/60 backdrop-blur-[6px]">
                                        <div className="flex flex-col items-center gap-4 rounded-3xl border border-white/40 bg-white/80 p-8 shadow-[0_8px_32px_0_rgba(31,38,135,0.07)] zoom-in-95 animate-in duration-300">
                                            <div className="relative flex h-14 w-14 items-center justify-center">
                                                <div className="absolute inset-0 animate-ping rounded-full bg-slate-900/5 opacity-20"></div>
                                                <LucidLoader additionalClasses="w-10 h-10 text-slate-900 animate-spin" />
                                            </div>
                                            <div className="flex flex-col items-center gap-1">
                                                <p className="text-base font-bold tracking-tight text-slate-900">Uploading File</p>
                                                <p className="text-xs font-medium text-slate-500">Syncing with cloud storage...</p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-5 relative">
                                    {isChatLoading && (
                                        <div className="absolute inset-0 z-50 flex items-center justify-center bg-slate-50/50 backdrop-blur-[2px]">
                                            <div className="flex flex-col items-center gap-4 rounded-2xl border border-white/40 bg-white/60 p-8 shadow-xl animate-in fade-in zoom-in duration-300">
                                                <LucidLoader additionalClass="!h-10 !w-10 animate-spin text-slate-900" />
                                                <p className="text-sm font-semibold text-slate-700">Syncing conversation...</p>
                                            </div>
                                        </div>
                                    )}

                                {activeTab === 'chat' ? (
                                    totalMessageCount ? (
                                        <div className="space-y-4">
                                            {keys.map((key) => (
                                                <div key={key} className="space-y-3">
                                                    <div className="sticky top-0 z-[1] flex justify-start py-1">
                                                        <span className="rounded-full border border-slate-200 bg-white/90 px-3 py-1 text-[11px] font-semibold text-slate-500 shadow-sm backdrop-blur">
                                                            {key}
                                                        </span>
                                                    </div>
                                                    {messages[key]?.map((chatMessage, index) => {
                                                        const isOwnMessage = chatMessage.userid === decodedJwt._id;
                                                        return (
                                                            <div key={`${chatMessage.key || key}-${index}`} className={`flex gap-2 ${isOwnMessage ? 'justify-end' : 'justify-start'}`}>
                                                                <div className={`max-w-[86%] ${isOwnMessage ? 'items-end' : 'items-start'} flex flex-col`}>
                                                                    <div className="mb-1 px-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-400">
                                                                        {name(chatMessage)}
                                                                    </div>
                                                                    <div className={`w-full rounded-2xl border px-3 py-2.5 shadow-sm ${isOwnMessage ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 bg-white text-slate-800'}`}>
                                                                        {renderMessageText(chatMessage.text, isOwnMessage)}
                                                                        {chatMessage.type === 'attachment' ? renderAttachmentCard(chatMessage, index, 'chat') : null}
                                                                    </div>
                                                                    <div className="mt-1.5 px-1 text-[10px] text-slate-400">
                                                                        {chatMessage.time}
                                                                    </div>
                                                                </div>
                                                                {decodedJwt?.userType === 'admin' && isOwnMessage ? (
                                                                    <button
                                                                        className="mt-6 h-8 w-8 shrink-0 rounded-full border border-rose-200 bg-white text-rose-500 shadow-sm transition hover:bg-rose-50"
                                                                        onClick={() => handleMessageDelete(chatMessage)}
                                                                    >
                                                                        <DeleteIcon additionalClasses="!text-rose-500" />
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                            <div ref={messagesEndRef} />
                                        </div>
                                    ) : renderEmptyState('No messages yet', 'Start the thread with a concise update or attach the first file.')
                                ) : (
                                    attachments.length ? (
                                        <div className="grid grid-cols-1 gap-3">
                                            {attachments.map((item, index) => (
                                                <div key={`${item.key || item.url}-${index}`} className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
                                                    <div className="mb-2 flex items-start justify-between gap-3">
                                                        <div className="min-w-0">
                                                            <p className="truncate text-sm font-semibold text-slate-800">{item.attachmentName}</p>
                                                            <p className="mt-1 text-xs text-slate-500">Shared by {name(item)} at {item.time}</p>
                                                        </div>
                                                        <span className="shrink-0 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-medium text-slate-500">
                                                            {item.createdon}
                                                        </span>
                                                    </div>
                                                    {renderAttachmentCard(item, index, 'att')}
                                                </div>
                                            ))}
                                        </div>
                                    ) : renderEmptyState('No attachments yet', 'Shared PDFs, screenshots, and drawings will appear here.')
                                )}
                            </div>
                        </div>

                            <div className="border-t border-slate-200 bg-white px-4 py-3 sm:px-5">
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    id='file-uploader'
                                    className="hidden"
                                    onChange={(event) => {
                                        const selectedFile = event.target.files?.[0];
                                        if (selectedFile) {
                                            uploadFiles(selectedFile);
                                        }
                                        event.target.value = '';
                                    }}
                                />
                                <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3 shadow-inner">
                                    <div className="compact-chat-quill">
                                        <ReactQuill
                                            theme="snow"
                                            value={message}
                                            onChange={setMessage}
                                            modules={quillModules}
                                            formats={quillFormats}
                                            placeholder="Write a clear update, ask a question, or leave context for the next step..."
                                        />
                                    </div>
                                    <div className="mt-2 flex items-center justify-between gap-3 border-t border-slate-200 pt-2.5">
                                        <div className="flex items-center gap-2">
                                            <button
                                                type="button"
                                                className="sync-chat-btn-attach"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    fileInputRef.current?.click();
                                                }}
                                            >
                                                Attach
                                            </button>
                                            <span className="text-[11px] text-slate-500">
                                                Rich text enabled
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            className="sync-chat-btn-send"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                onSend();
                                            }}
                                        >
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <PDFModalViewer
                    show={pdfModalInfo.show}
                    handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
                    fileName={pdfModalInfo.fileName}
                    pdfUrl={pdfModalInfo.pdfUrl}

                />
                <ImageModalViewer
                    show={imageModalInfo.show}
                    handleClose={() => setImageModalInfo({ show: false, fileName: '', imageUrl: '' })}
                    fileName={imageModalInfo.fileName}
                    imageUrl={imageModalInfo.imageUrl}
                />
            </div>
        </>
    );
}

export default Chat;
